import { useState, type KeyboardEvent } from 'react';

interface SettingsInputProps {
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
    type?: 'text' | 'number' | 'time';
    width?: number | 'full';
    disabled?: boolean;
    onKeyDown?: (event: KeyboardEvent<HTMLInputElement>) => void;
}

/** Design-system `Input` size `sm` — 36px, 1.5px border, radius-10, 13.5/700. */
export default function SettingsInput({
    value,
    onChange,
    placeholder,
    type = 'text',
    width = 'full',
    disabled = false,
    onKeyDown,
}: SettingsInputProps) {
    const [focus, setFocus] = useState(false);
    return (
        <input
            type={type}
            value={value}
            disabled={disabled}
            placeholder={placeholder}
            onChange={(event) => onChange(event.target.value)}
            onKeyDown={onKeyDown}
            onFocus={() => setFocus(true)}
            onBlur={() => setFocus(false)}
            className="cpm-settings-input"
            style={{
                boxSizing: 'border-box',
                width: width === 'full' ? '100%' : width,
                height: 36,
                padding: '0 13px',
                borderRadius: 'var(--cpm-radius-10)',
                border: `1.5px solid ${
                    focus ? 'var(--cpm-brand-purple)' : 'var(--cpm-border-strong)'
                }`,
                background: disabled ? 'var(--cpm-surface-subtle)' : '#fff',
                boxShadow: focus ? 'var(--cpm-ring-focus)' : 'none',
                fontFamily: 'var(--cpm-font-sans)',
                fontSize: 13.5,
                fontWeight: 700,
                color: 'var(--cpm-text-primary)',
                outline: 'none',
            }}
        />
    );
}

export function PlusIcon() {
    return (
        <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
        >
            <path d="M12 5v14M5 12h14" />
        </svg>
    );
}
